import { render, staticRenderFns } from "./BulletinReactionButtonAdd.vue?vue&type=template&id=17629aea&scoped=true&"
import script from "./BulletinReactionButtonAdd.vue?vue&type=script&lang=ts&"
export * from "./BulletinReactionButtonAdd.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17629aea",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VImg } from 'vuetify/lib/components/VImg';
import { VMenu } from 'vuetify/lib/components/VMenu';
installComponents(component, {VCard,VImg,VMenu})
